// extracted by mini-css-extract-plugin
module.exports = {"stories":"StoriesComponent_stories__DwjYN","listStories":"StoriesComponent_listStories__4BnR2","item":"StoriesComponent_item__3OyXQ"};